import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { InventoryService } from 'src/app/services/inventory.service';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { PDFService } from '../../services/pdf.service';


@Component({
  selector: 'app-item-sidebar',
  templateUrl: './item-sidebar.component.html',
  styleUrls: ['./item-sidebar.component.scss']
})
export class ItemSidebarComponent implements OnInit {
    @Input() 
    public item: InventoryItem;

    @ViewChild('autosize') autosize: CdkTextareaAutosize;

    public allItemTypes: any[] = [];

    constructor(
        private inventoryService: InventoryService,
        private _ngZone: NgZone,
        private router: Router,
        private pdfService: PDFService
        ) { }

    ngOnInit(): void {
        if (this.item.log == undefined) {
            this.item.log = [];
        }

        this.inventoryService.getItemTypes().subscribe((reply: any) => {
            this.allItemTypes = reply;
        })    
    }

    triggerResize() {
      // Wait for changes to be applied, then trigger textarea resize.
      this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
    }

    pickDecision(decision: string) {
        if (this.item.decision == decision) {
            this.item.decision = "";
        } else {
            this.item.decision = decision;
        }
        this.save();
    }

    toggleCheckout() {
        this.inventoryService.toggleCheckout(this.item).subscribe();
    }

    archive() {

        if (this.item.status != "Archived") {
            this.item.status = "Archived";
            this.item.decision = "";
            this.addLog("Archived");
        } else {
            if (this.item.improvementRequest != "") {
                this.item.status = "Needs Improvement";
            } else {
                this.item.status = "";
            }

            this.addLog("Un-Archived");
        }

        this.save();
    }

    resetStatus() {
        this.item.status = "";
    }


    
    click() {
        console.log(this.item)
    }

    addLog(value: string) {
        if (this.item.log == undefined) {
            this.item.log = [];
        }

        this.item.log.push({
            text: value,
            date: new Date()
        });
        
        this.save();
    }

    resetLog() {
        this.item.log = [];
        this.addLog("Log was cleared");
    }

    save() {
        this.item.lastModified = new Date();
        this.inventoryService.updateOne(this.item).subscribe(r => {});
    }

    delete () {
        this.inventoryService.deleteOne(this.item).subscribe((r: any) => {
            this.router.navigate(["inventory"]);
        })
    }

    saveItemType(category: number) {
        this.item.lastModified = new Date();
        this.addLog("Changed type from " + this.item.category + " to " + category);
        this.item.category = category;

        this.inventoryService.updateOne(this.item).subscribe(r => {
            window.location.reload()
        });
    }

    printBarcode() {

    }

    printA5() {
        //this.pdfService.download("test", {test: "tesxst"}, (r: any) => {});
        this.pdfService.print("test", {test: "tesxst"}, (r: any) => {});
    }

    openSaleChannelDialog() {

    }

    switchToTemplateEditor() {
        this.router.navigate(["/settings/item-template-editor", this.item.category])
    }
}
